import React from 'react';
import PropTypes from 'prop-types';
import { roundInt, roundFloat } from '../../helpers/helpers';
import './InfoValueCard.css';

const InfoValueCard = ({
  title,
  loading,
  value,
  hasPercentage,
  percentage,
  color,
  className,
  style,
  amount,
  moneda,
  onClick,
  selected,
  secondAmount,
  secondAmountLabel,
  showMoneda,
  showSecondAmountMoneda,
  amountLabel,
}) => {
  let formattedAmount = null;
  if (amount !== undefined) {
    formattedAmount = Number.isInteger(amount) ? roundInt(amount) : roundFloat(amount);
  }

  let formattedSecondAmount = null;
  if (secondAmount !== undefined) {
    formattedSecondAmount = Number.isInteger(secondAmount) ? roundInt(secondAmount) : roundFloat(secondAmount);
  }

  let formattedValue = '-';
  if (value !== undefined) {
    formattedValue = Number.isInteger(value) ? roundInt(value) : roundFloat(value);
  }

  const formattedPercentage = Number.isInteger(percentage)
    ? roundInt(percentage)
    : roundFloat(percentage);

  return (
    <div
      className={`info-value-card d-flex flex-column justify-content-between ${
        selected ? 'info-value-card--selected' : ''
      } ${className}`}
      style={{ borderLeftColor: color, ...style }}
      onClick={onClick}
    >
      <div className="info-value-card__title">{title}</div>
      <div
        className={`info-value-card__content ${loading ? 'info-value-card__content--loading' : ''}`}
      >
        {!loading ? (
          <>
            {formattedAmount !== null && (
              <div className="info-value-card__uf" style={{ borderLeftColor: color }}>
                {formattedAmount}{moneda && showMoneda ? ` ${moneda.toUpperCase()}` : ''}{amountLabel ? ` ${amountLabel}` : ''}
              </div>
            )}

            
            {formattedSecondAmount !== null && (
              <div className="info-value-card__secondary">
                {secondAmountLabel && (
                  <span className="info-value-card__secondary-label">{secondAmountLabel}</span>
                )}
                <span className="info-value-card__secondary-amount" style={{ color }}>
                  {formattedSecondAmount}{moneda && showSecondAmountMoneda ? ` ${moneda.toUpperCase()}` : ''}
                </span>
              </div>
            )}

            {(value !== undefined || hasPercentage) && (
              <div className="info-value-card__value" style={{ color: color }}>
                {formattedValue}
                {hasPercentage && (
                  <span className="info-value-card__value--pcg">
                    ({formattedPercentage ? formattedPercentage : 0}%)
                  </span>
                )}
              </div>
            )}
            <div
              className="info-value-card__progress-bar"
              style={{
                color: color,
                opacity: percentage !== undefined ? '1' : '0',
              }}
            >
              <div
                className="info-value-card__progress-bar__filled"
                style={{
                  width: `${percentage !== undefined ? percentage : 0}%`,
                  backgroundColor: color,
                }}
              ></div>
            </div>
          </>
        ) : (
          <>
            <div className="info-value-card__value--skeleton"></div>
            <div
              className="info-value-card__progress-bar info-value-card__progress-bar--skeleton"
              style={{
                opacity: hasPercentage ? '1' : '0',
              }}
            ></div>
          </>
        )}
      </div>
    </div>
  );
};

InfoValueCard.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  value: PropTypes.number,
  hasPercentage: PropTypes.bool,
  percentage: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  amount: PropTypes.number,
  moneda: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  secondAmount: PropTypes.number,
  secondAmountLabel: PropTypes.string,
  showMoneda: PropTypes.bool,
  showSecondAmountMoneda: PropTypes.bool,
  amountLabel: PropTypes.string,
};

InfoValueCard.defaultProps = {
  loading: false,
  value: undefined,
  hasPercentage: false,
  percentage: undefined,
  color: 'inherit',
  className: '',
  style: {},
  amount: undefined,
  moneda: 'UF',
  onClick: undefined,
  selected: false,
  secondAmount: undefined,
  secondAmountLabel: undefined,
  showMoneda: true,
  showSecondAmountMoneda: true,
  amountLabel: undefined,
};

export default InfoValueCard;
